<template>
  <svg width="18" height="18" viewBox="0 0 18 18" class="tw-fill-namaGray dark:tw-fill-white" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7195_1809)">
      <mask id="mask0_7195_1809" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="19">
        <path d="M0 0.000854492H18V18.0009H0V0.000854492Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_7195_1809)">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.25 0.000854492C14.6642 0.000854492 15 0.336641 15 0.750854V6.75085C15 7.16507 14.6642 7.50085 14.25 7.50085C13.8358 7.50085 13.5 7.16507 13.5 6.75085V0.750854C13.5 0.336641 13.8358 0.000854492 14.25 0.000854492Z"
        />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.5 3.75085C10.5 3.33664 10.8358 3.00085 11.25 3.00085H17.25C17.6642 3.00085 18 3.33664 18 3.75085C18 4.16506 17.6642 4.50085 17.25 4.50085H11.25C10.8358 4.50085 10.5 4.16506 10.5 3.75085Z"
        />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0 7.50085C0 3.33664 3.33579 0.000854492 7.5 0.000854492C7.91423 0.000854492 8.25 0.336641 8.25 0.750854C8.25 1.16506 7.91423 1.50085 7.5 1.50085C4.16421 1.50085 1.5 4.16506 1.5 7.50085C1.5 10.8366 4.16421 13.5009 7.5 13.5009C9.95722 13.5009 12.0992 11.9709 13.0379 9.82525C13.2039 9.44576 13.6461 9.27273 14.0256 9.4387C14.4051 9.60475 14.5781 10.047 14.4121 10.4265C13.2508 13.0809 10.5928 15.0009 7.5 15.0009C3.33579 15.0009 0 11.6651 0 7.50085Z"
        />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.7697 11.7706C12.0626 11.4777 12.5375 11.4777 12.8304 11.7706L17.7804 16.7206C18.0732 17.0134 18.0732 17.4883 17.7804 17.7812C17.4875 18.0741 17.0126 18.0741 16.7197 17.7812L11.7697 12.8312C11.4768 12.5383 11.4768 12.0634 11.7697 11.7706Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7195_1809">
        <rect width="18" height="18" fill="white" transform="translate(0 0.000854492)"/>
      </clipPath>
    </defs>
  </svg>
</template>
